require('jquery-simplyscroll');

// SHARE WINDOWS
function open_window(url, width, height) {
    var my_window;

    // screen.width means Desktop Width
    // screen.height means Desktop Height

    var center_left = (screen.width / 2) - (width / 2);
    var center_top = (screen.height / 2) - (height / 2);

    my_window = window.open(url, "Title", "scrollbars=1, width="+width+", height="+height+", left="+center_left+", top="+center_top);
    my_window.focus();
}

function get_shares(url, share_target) {
    var tempURL = "www.mymodernmet.com/profiles/blogs/fort-mcmurray-pets-in-cabin";

    addthis.init();

    addthis.sharecounters.getShareCounts({service: 'facebook', countUrl: tempURL}, function(obj) {
        console.log(obj)
        document.getElementById(share_target).innerHTML = obj["share"]["share_count"];
    });

}

var $ = jQuery.noConflict();

jQuery(document).ready(function() {

    // $('.featured-articles-wrapper').slick({
    //     slidesToShow: 2,
    //     slidesToScroll: 1,
    //     dots: true,
    //     infinite: false,
    //     arrows: false
    // });

	// Sticky Navigation
    var b = 1170;
    if ($(window).width() > b) {
        var c = $(".main-nav").height();
        $(window).on("scroll", {
            previousTop: 0
        }, function() {
            var b = $(window).scrollTop();
            b < this.previousTop ? b > 0 && $(".main-nav").hasClass("is-fixed") ? $(".main-nav").addClass("is-visible") : $(".main-nav").removeClass("is-visible is-fixed") : ($(".main-nav").removeClass("is-visible"), b > c && !$(".main-nav").hasClass("is-fixed") && $(".main-nav").addClass("is-fixed")), this.previousTop = b
        })
    }

	// STICKY NAV
	var header = $('.site-header'),
		navbar = $('#navbar-main'),
    	distance = header.offset().top,
        $window = $(window);

    if ($(window).width() > 990) {
	    $window.scroll(function() {
	        if ($window.scrollTop() >= distance) {
	            navbar.removeClass('navbar-fixed-top').addClass('navbar-fixed-top');
	          	$("body").css("padding-top", "70px");
	        } else {
	            navbar.removeClass('navbar-fixed-top');
	            $("body").css("padding-top", "0px");
	        }
	    });
	}


    $('.category_select').on('change', function () {
        var url = $(this).val(); // get selected value
        if (url) { // require a URL
            window.location = url; // redirect
        }
        return false;
    });

    // Popular Articles Sizing
    function popularArticlesSizing() {
        var elems = $('.popular-articles.desktop .article-link'),
            heightToSet = 0;

        if(elems.length > 0) {
            elems.css('height', '');

            if($(window).width() > 768) {
                elems.each(function (i,e) {
                    if($(this).height() > heightToSet) {
                        heightToSet = $(this).height();
                    }
                });

                elems.css('height', heightToSet);
            }
        }
    }

    // Shop Item Sizing
    function shopItemSizing() {
        var elems = $('.featured-product-container'),
            heightToSet = 0;

        if(elems.length > 0) {
            elems.css('height', '');

            if($(window).width() < 551) {
                elems.each(function (i,e) {
                    if($(this).outerHeight() > heightToSet) {
                        heightToSet = $(this).outerHeight();
                    }
                });

                elems.css('height', heightToSet);
            }
        }
    }

    popularArticlesSizing();
    shopItemSizing();

    $(window).on('resize', function () {
        popularArticlesSizing();
        shopItemSizing();
    });


    // Academy Scripts

    if($('.academy-full-width').length) {

        sizeMarqueeContainer();
        $(window).on('resize', function () {
            sizeMarqueeContainer();
        });

        let sliders = {};

        $('.image-marquee-container .column').each(function (i, e) {
            let slider = $(this).slick({
                vertical: true,
                // rtl: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 0,
                cssEase: 'linear',
                speed: 8000,
                pauseOnHover: false,
                arrows: false,
                centerMode: true
            });

            sliders['slide-' + i] = slider;
        });

        $('.image-marquee-pause-button').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if($(this).hasClass('is-paused')) {
                for(let i = 0; i < 4; i++) sliders['slide-' + i].slick({
                    vertical: true,
                    // rtl: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 0,
                    cssEase: 'linear',
                    speed: 8000,
                    pauseOnHover: false,
                    arrows: false,
                    centerMode: true
                });
                for(let i = 0; i < 4; i++) sliders['slide-' + i].slick('slickPlay');
                $(this).removeClass('is-paused');
            } else {
                for(let i = 0; i < 4; i++) sliders['slide-' + i].slick('unslick');
                $(this).addClass('is-paused');
            }
        });

        // $('.academy-full-width').on('mouseover', function () {
        //     for(let i = 0; i < 4; i++) {
        //         sliders['slide-' + i].slick('slickPlay');
        //     }
        // });
        //
        // $('.academy-full-width').on('mouseout', function () {
        //     for(let i = 0; i < 4; i++) {
        //         sliders['slide-' + i].slick('slickPause');
        //     }
        // });

        // $(sliders).each(function (i, e) {
        //     setTimeout(function () {
        //
        //     });
        // });

    }

    function sizeMarqueeContainer() {
        $('.academy-full-width .column-right').css('height', $('.academy-full-width .column-left .inner-container').outerHeight() + 40);
    }

    // $('.image-marquee-container .column').each(function (i,e) {
    //     $(e).simplyScroll({
    //         speed: 1,
    //         orientation: 'vertical',
    //         auto: true,
    //         startOnLoad: true
    //     });
    // });

    // End Academy Scripts




    // $('.single .article p').each(function() {
    //     var thisText = $(this).text();
    //     var thisHTML = $(this).html();
    //     var pclass = $(this).attr("class");
    //
    //     //alert( thisText.substr(0,1) );
    //
    //     // first is a char, not caption text, not an image and not a link
    //     if( thisHTML.charAt(0).match(/[a-z]/i) && pclass !== "wp-caption-text" && thisHTML.substr(0, 4) != "<img") {
    //
    //         var first = $('<span>'+thisHTML.charAt(0)+'</span>').addClass('caps');
    //         $(this).html(thisHTML.substring(1)).prepend(first);
    //         return false;
    //     }
    //
    //     else if( thisHTML.substr(0, 2) == "<a" ) {
    //         return false;
    //     }
    //
    // });

    /*
    $('.page .article p').each(function() {
        var text = $(this).html();
        if(text.charAt(0).match(/[a-z]/i)) {
            var first = $('<span>'+text.charAt(0)+'</span>').addClass('caps');
            $(this).html(text.substring(1)).prepend(first);
            return false;
        }
    });
    */

    /*
	$('.article p:first-letter').html(function (i, html) {
    	return html.replace(/^[^a-zA-Z]*([a-zA-Z])/g, '<span class="caps">$1</span>');
	});
    */

	// social hover
    /*
	$('.home-featured-article .overlay').hover(function(){
		$(this).find('.share-count').toggleClass('hide');
        $(this).find('.share-options').toggleClass('show');
    });
    */

    if ( $(window).width() > 768) {
        $(document).on({
            mouseenter: function () {
                $(this).find('.featured-image a').addClass('zoom-image');
            },
            mouseleave: function () {
                $(this).find('.featured-image a').removeClass('zoom-image');
            }
        }, ".featured-articles.desktop .featured-col");

        $(document).on({
            mouseenter: function () {
                $(this).find('.image a').addClass('zoom-image');
            },
            mouseleave:function () {
                $(this).find('.image a').removeClass('zoom-image');
            }
        }, ".small-article");

        $(document).on({
            mouseenter: function () {
                $(this).find('.image a').addClass('zoom-image');
            },
            mouseleave:function () {
                $(this).find('.image a').removeClass('zoom-image');
            }
        }, ".large-article");

        $(document).on({
            mouseenter: function () {
                $(this).find('.featured-image a').addClass('zoom-image');
            },
            mouseleave:function () {
                $(this).find('.featured-image a').removeClass('zoom-image');
            }
        }, ".featured-articles.related .featured-col");
    }



    $('.dropdown-toggle').click(function(e){
    	e.preventDefault();
    	$('.popular-caret-top').toggleClass('show_item', $('.popular-caret-top').is(":visible"));
        $('.popular-nav-menu').toggleClass('show_item', $('.popular-nav-menu').is(":visible"));
    });

    $('.popular-dropdown').click(function(e){
    	e.preventDefault();
		$('.popular-caret-top').toggleClass('show_item');
        $('.popular-nav-menu').toggleClass('show_item');
    });

	// Anchor Scroll
	$('.anchor-link').click(function(){
        $('html, body').animate({
            scrollTop: $( $.attr(this, 'href') ).offset().top
        }, 500);
        $('#get-newsletter #input_1_2').focus();
        return false;
    });

    $('.collapse-arrow').click( function(e) {
		e.preventDefault();
		//$(this).find('.feature-overlay').toggleClass('up');
		$(this).find('.ss-icon').toggleClass('hover rotate');
		//$(this).find('.ss-icon').toggleClass('ss-navigateup');
		//$(this).find('.ss-icon').toggleClass('ss-navigateright');
	});

    $('.single .featured-col').matchHeight();

    function iframeClasses() {
        $('.section-intro iframe').each(function (i,e) {
            var src = $(this).attr('src');
            if(typeof src !== 'undefined') {
                if(src.includes('facebook')) {
                    $(this).addClass('facebook-iframe');
                }
            }
        });
    }
    iframeClasses();


    function firstLetterCheck() {

        var paragraphs = $('body.single article p'),
            firstLetterSet = false;



        paragraphs.each(function (i, e) {
            if(!firstLetterSet) {
                if(!$(this).parent('blockquote').hasClass('reddit-card') &&
                    !$(this).parent('blockquote').hasClass('twitter-tweet') &&
                    $(this).html().replace(/(<([^>]+)>)/ig,"") !== "") {
                    if(!$(this).hasClass('wp-caption-text')) {
                        // remove any img tags
                        // var text = $(this).html().replace(/<img[^>]*>/g,"");
                        // strip html
                        var text = $(this).text().replace(/(<([^>]+)>)/ig,"");
                        // remove any links
                        text = text.replace(/<a\b[^>]*>(.*?)<\/a>/ig,"");

                        // remove noscript tags
                        text = text.replace(/<noscript\b[^>]*>(.*?)<\/noscript>/ig,"");

                        text = text.replace('&nbsp;', '');

                        text = text.trim();

                        if(text !== "") {
                            $(this).addClass('first-letter-styles');
                            firstLetterSet = true;
                        } else {
                            firstLetterSet = false;
                        }
                    }
                }
            }
        });
    }

    // if($('#one-signal-category').length) {
    //
    //     var numVisitsTrigger = 2; /* Number of page visits before tagging user */
    //     var topic = $('#one-signal-category').val(); /* The topic of the page */
    //
    //     function tagUserWithPageTopic(key, value) {
    //         console.log('here');
    //         console.log(OneSignal);
    //         OneSignal.push(function() {
    //             OneSignal.isPushNotificationsEnabled(function(isEnabled) {
    //                 console.log("isEnabled: ", isEnabled);
    //                 if (isEnabled) {
    //                     OneSignal.sendTag(key, value, function(tagsSent) {
    //                         // Callback called when tags have finished sending
    //                         console.log('tags sent: ', tagsSent);
    //                     });
    //                 }
    //             });
    //         });
    //     }
    //
    //     if (typeof localStorage !== "undefined") {
    //       var topicVisits = parseInt(localStorage.getItem(topic), 10);
    //       if (!isNaN(topicVisits)) {
    //         topicVisits += 1;
    //       } else {
    //         topicVisits = 0;
    //       }
    //       localStorage.setItem(topic, topicVisits)
    //
    //       if (topicVisits >= numVisitsTrigger) {
    //         tagUserWithPageTopic(topic, topicVisits);
    //       }
    //     }
    //
    //     OneSignal.push(function() {
    //         OneSignal.on('subscriptionChange', function(isSubscribed) {
    //             if (isSubscribed === true) {
    //                 console.log('The user subscription state is now:', isSubscribed);
    //                 OneSignal.sendTags({
    //                     "subscription_page": window.location.pathname,
    //                     "subscription_page_topic": topic,
    //                 }).then(function(tagsSent) {
    //                     // Callback called when tags have finished sending
    //                     console.log(tagsSent);
    //                 });
    //             }
    //         });
    //     });
    // }

    if($('body.single').length) {
        var isFirstPage = true;
        for(var firstCheckIndex = 2; firstCheckIndex < 10; firstCheckIndex++) {
            if($('body.single').hasClass('single-paged-' + firstCheckIndex)) {
                console.log('Skipping because not the first page');
                isFirstPage = false;
            }
        }
        if(isFirstPage) firstLetterCheck();
    }

    // if($('.category-label-es').length) {
    //     var aTags = $('.category-label-es').find('a');
    //     aTags.each(function () {
    //         if($(this).html() === "Home") {
    //             $(this).html('Inicio');
    //         }
    //     });
    // }


    // TODO: copy for French, cleanup after
    if($('.page-contacto').length && $('.gform_wrapper').length && $('#is-spanish-page').length) {
        var inputs = $('.page-contacto .gform_wrapper input[type=submit]');
        inputs.each(function () {
            if($(this).val() === "Submit") {
                $(this).val('Enviar');
            }
        });

        var gfieldLabels = $('.gfield_label');
        gfieldLabels.each(function () {
            if($(this).html() === "Name") {
                $(this).html('Nombre');
            } else if($(this).html() === "Email") {
                $(this).html('Correo electrónico');
            } else if($(this).html() === "Comment") {
                $(this).html('Comentario');
            }
        });
    }

    if($('.popular-posts-dropdown').length) {
        function setPopularPostsLocation() {
            console.log('Setting Popular Posts Position');
            var offsetNeeded = $('.popular-dropdown-parent-button').offset().left - $("#navbar-main").offset().left;
            $('.popular-posts-dropdown').css('left', 0 - offsetNeeded);
            $('.popular-posts-dropdown .caret-top').css('left', offsetNeeded + 45);
        }
        if($(window).width() > 1399) {
            setPopularPostsLocation();
        }

        $(window).on('resize', function () {
            if($(window).width() > 1399) {
                setPopularPostsLocation();
            }
        });
    }

    // $.post(ajaxurl, {
    //     action: 'is_user_logged_in'
    // }, function(response) {
    //     if(response.toString() === 'yes') {
    //         console.log('here');
    //     } else {
    //         console.log('there');
    //     }
    // });

    function checkLoggedInStatus() {
        console.log('Checking logged in status...');

        if(getCookie('wp-user-has-logged-in')){
            console.log('User is logged in');
        }else{
            console.log('User is not logged in');
        }
    }

    // checkLoggedInStatus();
    // This should be good, looks like this cookie does get used


    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');

        // console.log(ca);

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            console.log(c);
            while (c.charAt(0) === ' ') c = c.substring(1);
            if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
        }
        return "";
    }


    if($("#memberful-page").length) {
        $('.item-question').on('click', function () {

            var parent = $(this).parent();

            if(parent.hasClass('question-is-open')) {
                parent.removeClass('question-is-open');
                parent.find(".item-answer").slideUp();
            } else {
                parent.addClass('question-is-open');

                var currentAnswer = parent.find(".item-answer");
                currentAnswer.slideDown();

                $('.question-answer-item').not(parent).removeClass('question-is-open');
                $('.item-answer').not(currentAnswer).slideUp();
            }

        });

        var membersSlider = $("#slider-items").slick({
            fade: true,
            arrows: false,
            infinite: false,
            adaptiveHeight: true
        });

        function sliderImageCheck() {
            $('#slider-items .slide-item').each(function () {
                var imageContainer = $(this).find('.image-container'),
                    imgItem = imageContainer.find('img').first();

                if($(window).width() > 991) {
                    if(imgItem.outerHeight() < imageContainer.outerHeight()) {
                        imageContainer.css({
                            'background-image': 'url(' + imgItem.attr('src') + ')',
                            'background-size': 'cover',
                            'background-position': 'center'
                        });
                        imgItem.css('display', 'none');
                    } else {
                        imageContainer.css({'background-image': '', 'background-size': '', 'background-position': ''});
                        imgItem.css('display', '');
                    }
                } else {
                    imageContainer.css({'background-image': '', 'background-size': '', 'background-position': ''});
                    imgItem.css('display', '');
                }
            });
        }

        sliderImageCheck();
        $(window).on('resize', function () {
            sliderImageCheck();
        });

        $("#slider-navigation .previous-slide").on('click', function () {
            membersSlider.slick('slickPrev');
        });

        $("#slider-navigation .next-slide").on('click', function () {
            membersSlider.slick('slickNext');
        });

        membersSlider.on('afterChange', function (event, slick, currentSlide) {
            var currentSlideCount = currentSlide + 1;

            $('.slide-dot').not($('.slide-dot-' + currentSlide)).removeClass('is-current-dot');
            $('.slide-dot-' + currentSlide).addClass('is-current-dot');

            if(currentSlideCount === 1) {
                $("#slider-navigation .previous-slide").addClass('disabled');
                $("#slider-navigation .next-slide").removeClass('disabled');
            } else if (currentSlideCount === slick.slideCount) {
                $("#slider-navigation .next-slide").addClass('disabled');
                $("#slider-navigation .previous-slide").removeClass('disabled');
            } else {
                $("#slider-navigation .previous-slide").removeClass('disabled');
                $("#slider-navigation .next-slide").removeClass('disabled');
            }
        });

        function membershipOptionsPositioning() {

            var headerSize = $('#member-intro').find('.image-container').height(),
                offset = .7;

            if($(window).width() > 2000) {
                offset = .4;
            }

            var firstItem = $('.plan-item').first(),
                columnOffset = firstItem.outerHeight() + 70;

            if($(window).width() < 1301) {
                columnOffset = firstItem.outerHeight() - 70;
            }

            if($(window).width() > 991) {
                $('.available-plans-inner').css('margin-top', 0 - columnOffset);
                // $('.available-plans-inner').css('margin-top', 0 - (headerSize * offset));
            } else {
                $('.available-plans-inner').css('margin-top', '');
            }

        }

        $(window).on('load', function (){
            membershipOptionsPositioning();
        });

        $(window).on('resize', function () {
            membershipOptionsPositioning();
        });
    }

});
